var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 416,
    viewBox: "0 0 337 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M123.333 248.698L277.598 43.8931H91.9779L-62.2891 248.698H123.333Z",
    fill: "url(#paint0_linear_15641_48928)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M24.5625 -91.7339L-81.5664 49.1644H46.1338L152.26 -91.7339H24.5625Z",
    fill: "url(#paint1_linear_15641_48928)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-117.694 176.088H-129.535L3.86842 -1.02148H15.7115L-117.694 176.088Z",
    fill: "url(#paint2_linear_15641_48928)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.888 57.0923H154.047L287.45 -120.017H299.291L165.888 57.0923Z",
    fill: "url(#paint3_linear_15641_48928)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.525 243.427H-131.371L151.556 -132.191H262.402L-20.525 243.427Z",
    fill: "url(#paint4_linear_15641_48928)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M-165.152 365.595H-276L6.92664 -10.0234H117.775L-165.152 365.595Z",
    fill: "url(#paint5_linear_15641_48928)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M214.279 16.8501H166.566L288.35 -144.832H336.062L214.279 16.8501Z",
    fill: "url(#paint6_linear_15641_48928)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M32.8032 65.2849H-25.4727L123.273 -132.191H181.549L32.8032 65.2849Z",
    fill: "url(#paint7_linear_15641_48928)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M78.3555 73.8203H136.631L-12.1148 271.299H-70.3906L78.3555 73.8203Z",
    fill: "url(#paint8_linear_15641_48928)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-44.5572 407.702C-47.4083 411.465 -51.8642 413.666 -56.5849 413.643L-160.994 413.14C-173.355 413.08 -180.343 398.933 -172.877 389.081L145.735 -31.3879C148.586 -35.1504 153.042 -37.3513 157.762 -37.3285L252.17 -36.8732C268.652 -36.7938 277.968 -17.9311 268.014 -4.79452L-44.5572 407.702Z",
    fill: "url(#paint9_linear_15641_48928)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15641_48928",
    x1: 89.0505,
    y1: 106.811,
    x2: 178.284,
    y2: 296.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F7FCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#DBF9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CAF5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAF3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F3B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15641_48928",
    x1: 48.1462,
    y1: 5.87857,
    x2: -13.2434,
    y2: -124.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F7FCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#DAF9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C6F5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BBF3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F3BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15641_48928",
    x1: -56.9118,
    y1: 8.5095,
    x2: -56.9118,
    y2: 226.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#91EC8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63E358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15641_48928",
    x1: 226.668,
    y1: 54.017,
    x2: 226.668,
    y2: -156.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8FEC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58E35E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15641_48928",
    x1: 65.513,
    y1: 254.495,
    x2: 65.513,
    y2: -9.05684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#91EC8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63E358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15641_48928",
    x1: -79.1114,
    y1: 215.832,
    x2: -79.1114,
    y2: -55.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8F3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8FEC98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58E366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15641_48928",
    x1: 251.315,
    y1: 14.6967,
    x2: 251.315,
    y2: -80.7022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#96EC8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BE358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15641_48928",
    x1: 78.0361,
    y1: 59.858,
    x2: 78.0361,
    y2: -106.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DCF9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7F3B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15641_48928",
    x1: 33.1204,
    y1: 79.2494,
    x2: 33.1204,
    y2: 246.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DBF9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F3B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15641_48928",
    x1: 13.6023,
    y1: 175.257,
    x2: 505.421,
    y2: 499.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49CE66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D562"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipTopLeft);
export default __webpack_public_path__ + "static/media/clip-top-left.55f291c52b89253f249a56ed918e60e0.svg";
export { ForwardRef as ReactComponent };